import Env from "core/env/Env";
import { envVars } from "core/env/envVars";

type EnvRecord = {
  VITE_BACKEND_BASE_URL?: string;
  BACKEND_BASE_URL?: string;
  BACKEND_URL?: string;
  VITE_LOGGING?: string;
  LOGGING?: string;
  VITE_TIMEOUT_MS?: string;
  TIMEOUT_MS?: string;
};

export default class ViteEnv implements Env {
  get(key: string) {
    if (!key || typeof key !== "string") {
      return undefined;
    }

    const viteVars = envVars as EnvRecord;
    const meta = import.meta as ImportMeta | undefined;
    const viteEnv = (meta?.env ?? {}) as EnvRecord;

    const nodeEnv =
      typeof process !== "undefined" && process.env
        ? (process.env as EnvRecord)
        : undefined;

    switch (key) {
      case "BACKEND_BASE_URL": {
        // 1) Primary: injected Vite env module
        if (viteVars.VITE_BACKEND_BASE_URL !== undefined) {
          return viteVars.VITE_BACKEND_BASE_URL;
        }

        // 2) Fallbacks: direct import.meta.env
        const fromVite =
          viteEnv.VITE_BACKEND_BASE_URL ??
          viteEnv.BACKEND_BASE_URL ??
          viteEnv.BACKEND_URL;

        if (fromVite !== undefined) {
          return fromVite;
        }

        // 3) Node / Jest / scripts (process.env)
        if (nodeEnv) {
          return (
            nodeEnv.VITE_BACKEND_BASE_URL ??
            nodeEnv.BACKEND_BASE_URL ??
            nodeEnv.BACKEND_URL
          );
        }

        return undefined;
      }

      case "LOGGING": {
        if (viteVars.VITE_LOGGING !== undefined) {
          return viteVars.VITE_LOGGING;
        }

        const fromVite = viteEnv.VITE_LOGGING ?? viteEnv.LOGGING;
        if (fromVite !== undefined) {
          return fromVite;
        }

        if (nodeEnv) {
          return nodeEnv.VITE_LOGGING ?? nodeEnv.LOGGING;
        }

        return undefined;
      }

      case "TIMEOUT_MS": {
        if (viteVars.VITE_TIMEOUT_MS !== undefined) {
          return viteVars.VITE_TIMEOUT_MS;
        }

        const fromVite = viteEnv.VITE_TIMEOUT_MS ?? viteEnv.TIMEOUT_MS;
        if (fromVite !== undefined) {
          return fromVite;
        }

        if (nodeEnv) {
          return nodeEnv.VITE_TIMEOUT_MS ?? nodeEnv.TIMEOUT_MS;
        }

        return undefined;
      }

      default:
        // Unknown keys are deliberately not resolved dynamically to avoid
        // bracket-notation lookups on arbitrary user-controlled input.
        return undefined;
    }
  }
}
